import { AngleLeftIcon, AngleRightIcon, Box, IconButton, Typography, useTheme } from '../..';
import React from 'react';
export const CardTablePaginationControls = ({ count, pageSize, offset, onPageChange }) => {
    const theme = useTheme();
    const startRange = offset > count - 1 ? count : offset + 1;
    const endRange = offset + pageSize > count ? count : offset + pageSize;
    const incrementPage = () => onPageChange(offset + pageSize);
    const decrementPage = () => onPageChange(offset - pageSize);
    return (React.createElement(Box, { display: "flex", alignItems: "center", justifySelf: "flex-end" },
        React.createElement(Typography, { variant: "subtitle1", fontWeight: "medium" },
            startRange,
            "-",
            endRange,
            " of ",
            count),
        React.createElement(IconButton, { disabled: offset === 0, onClick: decrementPage },
            React.createElement(AngleLeftIcon, { htmlColor: theme.palette.text.secondary })),
        React.createElement(IconButton, { disabled: offset + pageSize >= count, onClick: incrementPage },
            React.createElement(AngleRightIcon, { htmlColor: theme.palette.text.secondary }))));
};
//# sourceMappingURL=Pagination.js.map